import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./bannerCarousel.css";
import CustomLoader from "../../../../shared/customLoader";
import BannerCarouselSkeleton from "../../../../assets/skeleton/bannerCarouselSkeleton";

function BannerCarousel({ bannerImages, onClick, bannerLoader }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 500);
  const sliderRef = useRef(null);

  useEffect(() => {

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 500);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Carousel Settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    prevArrow: <button className="slick-prev">Previous</button>,
    nextArrow: <button className="slick-next">Next</button>,
    pauseOnHover : true,
     pauseOnFocus: true,
  };

  return (
    <div className="">
      {!bannerLoader ? (
        <Slider
          {...settings}
          spaceBetween={30}
          slidesPerView={1}
          adaptiveHeight={true}
          navigation
          pagination={{ clickable: true }}
          ref={sliderRef}
        >
          {bannerImages?.map((img, i) => {
            return (
              <div
                key={i}
                onClick={(e) => {
                  onClick(e, bannerImages[i]?._id, i);
                }}
                onTouchStart={() => sliderRef.current?.slickPause()}
                onTouchEnd={() => sliderRef.current?.slickPlay()}
                onMouseEnter={() => sliderRef.current?.slickPause()}
                onMouseLeave={() => sliderRef.current?.slickPlay()}
              >
                <img style={{aspectRatio : isMobile ? "3 / 2" : "10 / 3"}}  src={isMobile && img.mobileImage ? img.mobileImage : img.imageName} className="w-100" alt="" />
              </div>
            );
          })}
        </Slider>
      ) : (
        <BannerCarouselSkeleton/>
      )}
    </div>
  );
}
export default BannerCarousel;
